import React from 'react';
import styled from "styled-components";
import './index.css'

export const CountDownContainer = styled.div`
position: fixed;
cursor: pointer;
bottom: 0;
z-index: 3;
display: flex;
width: 100%;
color: white;
background: ${({ theme, backgroundColor='secondary' }) => theme.colors[backgroundColor]};
${({bgImage}) => bgImage ? `background-image: url(${bgImage});` : ''}
// background: url(https://static.stgairasia.com/seo/static-assets/SEOAssets/campaigns/ripple-bg.png);
min-height: 60px;
max-height: 140px;
height: auto;
// display: flex;
justify-content: center;
align-items: center;
font-weight: bold;
font-size: 16px;
letter-spacing: 1.5px;
// font-family: monospace;
padding: 8px;
box-sizing: border-box;
text-align: center;
flex-direction: column;
gap: 0px;
& .countdownIcon{
  // display: none;
  font-size: 18px !important;
}
& .close-icon-btn{
  display: none;
}
@media only screen and (max-width: 990px) {
  background-color: #727272dd;
  padding: 0px;
  min-height: unset;
  height: 100vh;
  max-height: none;
  z-index: 12;
  top: 0;
  & img[alt="banner image"]{
    width: auto !important;
    height: auto !important;
  }
  & img[alt^="bgImage"]{
    display: none !important;
  }
  & .close-icon-btn{
    display: block;
  }
}
@media only screen and (min-width: 976px) {
  flex-direction:row;
  gap: 8px;
  & .countdownIcon{
    display: inline-flex;
  }
}
@media only screen and (min-width: 1260px) {
  font-size: 24px;
}
& .inverseColorText{
  color: rgb(220, 50, 36);
  background: white;
  padding-inline: 4px;
}
`;

export const PrimaryColorText = styled.span`
color: ${({ theme }) => theme.colors['secondary']};
`;

export const CountDownText = ({ number, unit='tenth', type='minutes'}) => {
  return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: 16, height: 16, fontFamily: 'monospace', fontWeight: 'bold', overflow: 'hidden' }}>
          <div style={{ fontFamily: '"Orbitron"', display: 'flex', justifyContent: 'center', alignContent: 'center', width: 16, height: 16, lineHeight: '16px', fontSize: "16px" }}>
            <PrimaryColorText>{number}</PrimaryColorText>
          </div>
      </div>
  );
};